import {
  constants,
  ListContent,
  ListItem,
  ListMedia,
  RulerIcon,
  Text,
} from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { messages } from '../../../../components/SizeGuide/messages';
import styles from './ProductTrustSignals.module.scss';

export interface SizeGuideTrustSignalProps {
  productTypeId: string;
  workId: number;
  onClick?: () => void;
}

const SizeGuideModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "SizeGuideModal" */
      'components/SizeGuide/SizeGuideModal'
    ).then(({ SizeGuideModal: Component }) => Component),
  { ssr: false, loading: () => null }
);

export const SizeGuideTrustSignal: React.FC<SizeGuideTrustSignalProps> = ({
  productTypeId,
  workId,
  onClick,
}) => {
  const intl = useIntl();

  const [open, setOpen] = useState(false);

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }

    setOpen(true);
  };

  const onClosedRequested = () => setOpen(false);

  return (
    <ListItem
      element="a"
      className={styles.pointer}
      onClick={() => handleOnClick()}
      arrow
    >
      <ListMedia>
        <RulerIcon size={constants.LARGE} />
      </ListMedia>
      <ListContent>
        <Text type="display5" display="block">
          {intl.formatMessage(messages.openButtonText)}
        </Text>
        <Text display="block" type="body2">
          {intl.formatMessage(messages.fitIndicatorTitle)}
        </Text>
      </ListContent>
      <SizeGuideModal
        open={open}
        onClosedRequested={() => onClosedRequested()}
        productTypeId={productTypeId}
        workId={workId}
      />
    </ListItem>
  );
};
